export enum EWeightMeasurementUnit {
	KILOGRAM = "kg",
	POUND = "lbs",
}
